var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"item-editor"}},[_c('div',{staticClass:"form-loader-w"},[(_vm.editingItem !== null)?_c('form-loader',{key:_vm.editingItem.id,attrs:{"form-instance":_vm.editingItem}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }